import {Injectable} from '@angular/core';
import {Endpoints} from "../../customs/endpoints";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {catchError, map, Observable, of, throwError} from "rxjs";
import {CommonResponse} from "../../customs/_models/Response";
import {SampleDTO} from "../../customs/_models/sampleDTO";
import {OT_DTO} from "../../customs/_models/OT_DTO";
import {error} from "@angular/compiler-cli/src/transformers/util";
import { SampleCountDTO } from '../../customs/_models/SampleCountDTO';
import { DevisDTO } from '../../customs/_models/DevisDTO';
import { environment } from '../../../environments/environment';
import { BonCommandeDTO } from '../../customs/_models/bonCommandeDTO';

@Injectable({
    providedIn: 'root'
})
export class DevisService {

    constructor(
        private endpoints: Endpoints,
        private http: HttpClient) {
    }

        private baseUrl = environment.base_url;
    

    private apiUrl = this.baseUrl+'/api/devis';
    private apiUrl1 = this.baseUrl+'/api/bdc';

    createDevis(devisDTO: DevisDTO) {
        return this.http.post<DevisDTO>(this.apiUrl, devisDTO, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        });
    }
    
  creerBonCommandeDepuisDevis(devisId: number): Observable<BonCommandeDTO> {
    return this.http.post<BonCommandeDTO>(`${this.apiUrl}/from-devis/${devisId}`, {});
  }
    update(id: number, devis: DevisDTO) {
        return this.http.put<any>(`${this.endpoints.devis_endpoint}/${id}`, devis);
    }
    
    
  /* createDevisS(devisData: DevisDTO): Observable<Blob> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        console.log('Envoi des données :', devisData);
    
        // Envoi du devis au backend et récupération du fichier PDF généré
        return this.http.post(`${this.apiUrl}/create-and-generate`, devisData, {
            headers: headers,
            responseType: 'blob'
        }).pipe(
            map((response: Blob) => {
                console.log('Réponse du backend (Blob reçu) :', response);
                return response;  // Retourne le Blob contenant le fichier PDF
            }),
            catchError(error => {
                console.error('Erreur lors de l\'appel à l\'API :', error);
                return throwError(error); // Renvoyer l'erreur pour qu'elle soit capturée par le composant
            })
        );
    }
    */

    generateBDC(sampleIds: number[]) {
      let url = `${this.apiUrl1}/pdf`;
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      
      return this.http.post(url, sampleIds, { headers, responseType: 'json' });
  }  
    
    generateDevis(sampleIds: number[]) {
        let url = `${this.endpoints.devis_endpoint}/create-download-devis`;
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        
        return this.http.post(url, sampleIds, { headers, responseType: 'json' });
    }  
      previewDevisPdf(devisIds: number[]): Observable<Blob> {
        return this.http.post
        (`${this.endpoints.devis_endpoint}/pdf/preview`, devisIds, {
          responseType: 'blob'
        });
      }
      
      validerDevis(id: number): Observable<DevisDTO> {
        return this.http.put<DevisDTO>(`${this.endpoints.devis_endpoint}/${id}/valider`, {});
      }
modifierDevis(id: number, action: string) {
  const body = { action };
  return this.http.put<DevisDTO>(`${this.apiUrl}/${id}/modifier`, body);
}



    EnCoursDevis(id: number): Observable<DevisDTO> {
        return this.http.put<DevisDTO>(`${this.endpoints.devis_endpoint}/${id}/enCours`, {});
      }
      
      envoyerDevis(id: number): Observable<DevisDTO> {
        return this.http.put<DevisDTO>(`${this.endpoints.devis_endpoint}/${id}/envoyer`, {});
      }
      accepterDevis(id: number, clientReference: string): Observable<DevisDTO> {
        return this.http.put<DevisDTO>(`${this.apiUrl}/${id}/accepter`, {
          clientReference: clientReference
        });
      }
      
      
      
      rejeterDevis(id: number): Observable<DevisDTO> { 
        return this.http.put<DevisDTO>(`${this.endpoints.devis_endpoint}/${id}/rejeter`, {});
      }
    
    updateDevisStatus(devisId: number, action: string): Observable<any> {
    const url = `${this.endpoints.devis_endpoint}/${devisId}/status`; // Mettez l'URL appropriée selon votre backend
    const body = { action: action };  // L'action à effectuer: 'accepter' ou 'rejeter'

    return this.http.put(url, body);  // Utilisation de PUT ou POST selon votre API
  }
    fetchAllDevis(){
        console.log(this.endpoints.devis_endpoint)
        return this.http.get<CommonResponse>(this.endpoints.devis_endpoint)
    }
    fetchAllBDC(){
        console.log(this.endpoints.devis_endpoint)
        return this.http.get<CommonResponse>(this.apiUrl1)
    }
    
    
    delete(id: number) {
        return this.http.delete<boolean>(`${this.endpoints.devis_endpoint}/${id}`)
    }

    deleteBDC(id: number) {
      return this.http.delete<boolean>(`${this.apiUrl1}/${id}`)
  }
    
          
    downloadDevis(devisIds: number[]): Observable<Blob> {
        const url = `${this.endpoints.devis_endpoint}/pdf`; // Mise à jour de l'URL pour accepter plusieurs IDs
        return this.http.post(url, devisIds, { responseType: 'blob' });
    }
    downloadBDC(devisIds: number[]): Observable<Blob> {
      const url = `${this.apiUrl1}/pdf`; // Mise à jour de l'URL pour accepter plusieurs IDs
      return this.http.post(url, devisIds, { responseType: 'blob' });
  }

}

interface SampleHeader {
    method: string;
    sampleName: string;
    sampleType: string;
}

interface Result {
    elem: string;
    unit: string;
    avg: number;
}

interface SampleData {
    header: SampleHeader;
    results: Result[];
}
